import $ from 'jquery';
import CacheData from '../../common/utils/cacheData';
import {BllinkLogger} from '../utils/bllink_loggers';

const cacheKey = 'oneTimeSelectedPayments';
export default class OneTimePaymentsLogic{


    static saveToCache(payments, buildingID, apartmentNumber){

        CacheData.cache(
            cacheKey,
            payments,
            {buildingID: buildingID, apartmentNumber: apartmentNumber}
        )
    }

    static fetchFromCache(payments, buildingID, apartmentNumber){

        BllinkLogger.info(`buildingID ${buildingID} apartmentNumber ${apartmentNumber} fetch initial one time  `, payments);

        BllinkLogger.info(`cacheKey to fetch ${cacheKey}`)
        const cacheOptions = {buildingID: buildingID, apartmentNumber: apartmentNumber};
        let result = CacheData.fetchCache(cacheKey , cacheOptions);
        if (!result){
            //https://app.asana.com/0/1196545425570329/1199116075316413 users had just one single one time payment
            // and it was unchecked by default and they got to the checkout page with an empty cart.
            // got an error from server when trying to pay
            BllinkLogger.info('returned from raw data ', payments);
            payments = payments.map(p=> {
                p.selected = p.selected || true
                return p
            })
            result = payments;
        }

        if (result.length > 0) {
            CacheData.cache(cacheKey, result, cacheOptions);
        }
        BllinkLogger.info(`result one time payments`, result);
        return result


    }

    static getCurrentSelectedStatus(payments){
       /*

        */

        let result = [];
        $('#jquery-one-time-box .jquery-oneTimeCheckBox').each(function(index, _){
            const isChecked = $(this).is(':checked');
            let correspondingOneTimePayment = payments[index];

            // todo also save the number of payments selected
            let partPay = $(this).parents('.js-one-time-parent').find('.js-part-pay')
            correspondingOneTimePayment.selected = isChecked;
            if (partPay && partPay.attr('value')){
                correspondingOneTimePayment.part_pay = {
                    value: partPay.attr('value'), currency: partPay.attr('currency'),
                    "time-index": partPay.attr('time-index'), "full-amount": partPay.attr('full-amount')
                }
            }
            result.push(correspondingOneTimePayment);
        });

        return result;
    }
}
